<template>
  <video-player
    v-if="
      (sources.length && options.sources?.length) ||
      (!sources.length && !context.video_source)
    "
    :autoplay="autoplay"
    :fluid="true"
    :liveui="true"
    :poster="poster"
    :src="src"
    aspect-ratio="16:9"
    class="relative"
    controls
    v-bind="options"
  >
    <template v-slot="{ player, state }">
      <div class="bg-red-600">
        <IconPlayerPlayFilled
          v-if="controls"
          :class="{
            '!opacity-0 !scale-[50%]': state.playing,
          }"
          class="text-white size-14 transition-all duration-100 opacity-90 scale-100 absolute left-1/2 -translate-y-1/2 -translate-x-1/2 top-1/2 pointer-events-none"
          size="112"
        />
      </div>
    </template>
  </video-player>
  <div v-else class="aspect-video w-full">
    <iframe
      :src="`https://video-cdn.gov-murman.ru/${context.video_source}?withoutTitle=true`"
      allowfullscreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      class="w-full h-full"
    />
  </div>
</template>

<script setup>
import { VideoPlayer } from '@videojs-player/vue'
import 'video.js/dist/video-js.css'
import { defineComponent, ref } from 'vue'

import { IconPlayerPlayFilled } from '@tabler/icons-vue'

defineComponent({
  components: {
    VideoPlayer,
  },
})

const props = defineProps({
  src: {
    type: String,
    default: '',
  },
  poster: {
    type: String,
    default: '',
  },
  controls: {
    type: Boolean,
    default: false,
  },
  sources: {
    type: Array,
    default: [],
  },
  autoplay: {
    type: Boolean,
    default: false,
  },
  context: {
    type: Object,
    default: () => ({}),
  },
})

const options = ref({})

if (props.sources.length) {
  options.value.sources = props.sources
}
</script>
